import { NARRATIVE_AUTHOR_FRAGMENT } from '@/components/NarrativeAuthor';
import { gql } from '@/utilities/gql';

export const NARRATIVE_FRAGMENT = gql(
  `
  fragment NarrativeFields on Narrative @_unmask {
    companyId
    contentBlocks {
      contentHtml
      id
      title
    }
    id
    slug
    title
    valuation {
      discountRate
      fairValue
      futurePePercentageChange
      futureSharesOutstanding
      profitMarginPercentageChange
      revenuePercentageChange
      timeframe
    }
    userHoldsPosition
    author {
      ...NarrativeAuthorFields
    }
    isPrimary
  }
`,
  [NARRATIVE_AUTHOR_FRAGMENT]
);
